import { render, staticRenderFns } from "./PinLayout.vue?vue&type=template&id=8d6fb0e6&scoped=true&"
import script from "./PinLayout.vue?vue&type=script&lang=js&"
export * from "./PinLayout.vue?vue&type=script&lang=js&"
import style0 from "./PinLayout.vue?vue&type=style&index=0&id=8d6fb0e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d6fb0e6",
  null
  
)

export default component.exports